import { Popover, PopoverContent, PopoverTrigger } from './Popover';
import { Calendar, CalendarProps } from './Calendar';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons/faCalendarRange';
import { DateTime } from 'luxon';
import { FaIcon } from '../FaIcon';
import { toLocaleDate } from '../../utils/date';
import { cn } from '../../utils';
import { getLocaleFromString } from './getLocaleFromString';

type DateRange = {
  start?: string | null;
  end?: string | null;
};

export const DatePicker = ({
  selectedDate,
  triggerClassName,
  placeholder,
  onSelect,
  allowedRange,
  locale: localeString,
  container,
  calendarProps,
}: {
  selectedDate?: Date,
  triggerClassName?: string;
  placeholder: string;
  onSelect: (date: Date) => void;
  locale?: string;
  allowedRange?: DateRange;
  container: HTMLElement;
  calendarProps?: Partial<CalendarProps>;
}) => {
  const locale = getLocaleFromString(localeString);

  const disabledDates = allowedRange && {
    before: new Date(allowedRange.start as string),
    after: new Date(allowedRange.end as string),
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className={cn(
            'lf:l-tab lf:l-tab-md lf:l-tab-tertiary lf:w-full lf:justify-start lf:text-left lf:text-body-md lf:text-neutral-500',
            triggerClassName
          )}
        >
          <FaIcon icon={faCalendarRange} className={!selectedDate ? "lf:text-neutral-500" : ""}/>
          {selectedDate ? (
            toLocaleDate(selectedDate.toISOString(), DateTime.DATE_FULL)
          ) : (
            <span className="lf:text-neutral-500">{placeholder}</span>
          )}
          <FaIcon icon={faChevronDown} className="lf:ms-auto" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="lf:w-auto lf:bg-neutral-0 lf:p-0" container={container}>
        <Calendar
          {...calendarProps}
          mode="single"
          selected={selectedDate}
          locale={locale}
          {...(disabledDates ? { disabled: disabledDates } : {})}
          onSelect={(date) => {
            if (date) {
              onSelect(date);
            }
          }}
          className="lf:rounded-md lf:border lf:border-neutral-200"
        />
      </PopoverContent>
    </Popover>
  );
};
